<div class="flex items-center py-4">
    <ng-container *ngFor="let item of breadcrumbs; let i = index">
        <div>
            <a *ngIf="item.routerLink; else noLink"
               [routerLink]="item.routerLink">
               <h6 class="text-gray-dark">{{ item.title }}</h6>
            </a>
    
            <ng-template #noLink>
                <h6 class="text-gray-light">{{ item.title }}</h6>
            </ng-template>
        </div>
        
        <div *ngIf="i < breadcrumbs.length - 1" class="flex items-center mx-4">
            <mat-icon class="md-18 text-gray-light">chevron_right</mat-icon>
        </div>
    </ng-container>
</div>